import Input from "components/atoms/input/Input";
import { Fragment, useEffect, useRef, useState } from "react";
import { checkMacAddressRegex } from "utils/regEx";
import { AutoInputStyled } from "./UtilityStyled";
import { toTrim } from "utils/functions";

type Props = {
  onChange: (value: string) => void;
};
export default function MacAddressInput(props: Props) {
  const [values, setValues] = useState(Array(6).fill("")); // 6칸
  const inputsRef = useRef<(HTMLInputElement | null)[]>([]);

  const handleChange = (
    index: number,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    let val = e.target.value.toUpperCase();
    if (val.length > 2) {
      val = val.slice(0, 2);
    }

    const newValues = [...values];
    newValues[index] = val;
    setValues(newValues);

    // 두 글자 다 입력되면 다음 칸으로 이동
    if (val.length === 2 && inputsRef.current[index + 1]) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select(); // focus시 자동 전체 선택
  };
  // 복붙할때 자동으로 입력값채워지도록 - 대신 aa:aa:aa:aa:aa:aa 로채워야함
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = toTrim(e.clipboardData.getData("text"));

    if (checkMacAddressRegex(pasted)) {
      e.preventDefault();
      const parts = pasted.split(":");
      setValues(parts.map((p) => p.toUpperCase()));
      // 마지막 칸 포커스
      inputsRef.current[parts.length - 1]?.focus();
    }
  };
  useEffect(() => {
    props.onChange(values.join(":"));
  }, [values]);

  return (
    <AutoInputStyled.Container>
      {values.map((val, i) => (
        <Fragment key={i}>
          <Input
            autoComplete="new-password"
            name="ignore-mac"
            maxLength={2}
            value={val}
            ref={(el) => (inputsRef.current[i] = el)}
            onChange={(e) => handleChange(i, e)}
            onFocus={handleFocus}
            onPaste={handlePaste}
            data-testid="maintenance-admin-unlock-admin-unlock-ignore-mac-change"
          />

          {i < values.length - 1 && (
            <AutoInputStyled.Separator>:</AutoInputStyled.Separator>
          )}
        </Fragment>
      ))}
    </AutoInputStyled.Container>
  );
}
